
import { Component, Vue } from 'nuxt-property-decorator'
import BlackFridayCompareCard from '~/components/black-friday/BlackFridayCompareCard.vue'

type CompareCards = Readonly<{ image: string, title: string, url: string }[]>

@Component({
  components: {
    BlackFridayCompareCard,
  },
})
export default class BlackFridayCompareCards extends Vue {
  readonly cards: CompareCards = Object.freeze([
    {
      image: require('~/assets/icons/black-friday/icon-bf-mobile.svg'),
      title: this.$t('blackFriday.moreDealsBanner.mobilePlans') as string,
      url: this.localePath('black-friday-mobile-plans'),
    },
    {
      image: require('~/assets/icons/black-friday/icon-bf-home.svg'),
      title: this.$t('blackFriday.moreDealsBanner.internetPlans') as string,
      url: this.localePath('black-friday-internet-plans'),
    },
  ])
}
